import { ChangeDetectionStrategy, Component } from '@angular/core';
import { AdminLoginForm } from '../components/admin-login';
import { AuthPageShell } from '../layout/auth-page-shell';

@Component({
  selector: 'lib-auth-admin-login-page',
  imports: [AuthPageShell, AdminLoginForm],
  template: `
    <lib-auth-page-shell>
      <lib-auth-admin-login-form />
    </lib-auth-page-shell>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AdminLoginPage {}
